export class Project
{
    projectId: string;
    projectName: string;
    platformId: string;
    platformName: string;
    platformType: string;
    platformUri: string;
    platformDomain: string;
    projectDescription: string;
    platformSegment: string;
    projectSegment: string;
}
